/**
 * Product translations (Diamond Recharge + VIP Subscription)
 * Includes: Payment process, product selection, etc.
 */
export default {
  // Common translations
  failedToLoadProducts: 'Failed to load products',
  selectPaymentMethod: 'Select Payment Method',
  purchase: 'Purchase',
  processing: 'Processing...',
  pleaseSelectPackage: 'Please select a package',
  pleaseSelectPayment: 'Please select a payment method',
  paymentFailed: 'Payment request failed, please try again',
  invalidPaymentResponse: 'Invalid payment response',
  buyDiamonds: 'Buy Diamonds',
  myBalance: 'My Balance: ',
  onlyLimitTimes: {
    '1': 'Only one time',
    '2': 'Only two times',
    '3': 'Only three times',
    '4': 'Only four times',
    '5': 'Only five times',
    '6': 'Only six times',
    '7': 'Only seven times',
    '8': 'Only eight times',
    '9': 'Only nine times',
    'other': 'Only {count} times'
  },
  paymentWindowOpenFailed: {
    title: 'Failed to open payment window',
    message: 'Browser may have blocked the popup, please click "Continue" to try again',
    continue: 'Continue',
  },

  // VIP subscription specific
  vip: {
    validUntil: 'VIP valid until {date}',
    notVipYet: "You're not a VIP yet",
    vipMember: "You're a VIP member",
    onlyOneTime: 'Limited',
    benefitsDescription:
      'As of {date}, your daily benefits are: free chatting, {oldDiamondCount} diamonds. After renewal, the daily benefits will be changed to diamond {newDiamondCount}/day.',
    onlyOneTimeBenefitsTitle: 'One-time benefits',
  },
}
